import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { Customer, Employee, QueryStoreConfigurationArgs, StoreConfiguration } from '@hdms/shared/common-types';

export interface TpmContextResponse {
  storeConfiguration: StoreConfiguration;
  loggedInContext: Customer | Employee;
}

export interface TpmContextArgs extends QueryStoreConfigurationArgs {
  isByDesign: boolean;
}

const fleetMasterContractFields = gql`
  fragment FleetMasterContractFields on FleetMasterContract {
    id
    status
    isCostCenterRequired
    fleetLabelingTemplate(localization: $localization) {
      id
      isInventoryNumberVisible
      isOrganizationalReferenceVisible
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class TpmContextGqlService extends Query<TpmContextResponse, TpmContextArgs> {
  override document = gql`
    query TpmStoreConfiguration($localization: LocalizationInput!, $isByDesign: Boolean!) {
      storeConfiguration(localization: $localization) {
        id
        common {
          restrictedDates
          termsAndConditions
        }
        toolParkManagement {
          circularityReports
          employeeFleetExchangeExtendToolProcess
          employeeFleetExchangeRenewToolProcess
          employeeFleetExchangeReturnToolProcess
          fleetExchangeExtendToolProcess
          fleetExchangeRenewToolProcess
          fleetExchangeToolProcess
          loanToolProcess
          peakToolProcess
          returnToolProcess
          toolDocumentsDownload
          toolListColumns
          toolParkManagement
          lostStolenToolProcess
          repairTrackingProcess
          toolRepairFields
          showRepairTrackingDates
          additionalPackagingDays
          employeeReturnToolProcess
          fleetPurchaseReturnDangerousToolProcess
          loanPeakReturnDangerousToolProcess
          showPickUpDate
          toolPickupAndDeliveryOptions
          lostToolsOathDeclarationRequired
          stolenToolsPoliceReportRequired
          stolenToolsPoliceReportFileExtensions
          employeeChangeCostCenterToolProcess
        }
      }
      loggedInContext {
        id
        ... on Customer {
          companyAccount {
            id
            originId
          }
          # not used but required in order to get companyAccount
          contact {
            id
          }
          fleetMasterContract(localization: $localization) @skip(if: $isByDesign) {
            ...FleetMasterContractFields
          }
        }
        ... on Employee {
          type
          customerCompanyAccount {
            id
            originId
          }
          customerContact {
            id
          }
          customerFleetMasterContract(localization: $localization) @skip(if: $isByDesign) {
            ...FleetMasterContractFields
          }
        }
      }
    }
    ${fleetMasterContractFields}
  `;
}
